import { isWidget, noticeError } from '@ratehub/base-ui';

import SCENARIOS from '../definitions/Scenarios';
import REWARD_SORT_OPTIONS from '../definitions/RewardSortOptions';
import LOW_INTEREST_SORT_OPTIONS from '../definitions/LowInterestSortOptions';


/**
 * Given a credit card scenario, return the appropriate object of sort options, but without
 * the Ratehub recommendations entry if called by a widget.
 *
 * @param {string} scenario
 * @return {Object}
 */
function getCreditCardSortOptions(scenario) {
    const creditCardSortOptions = CREDIT_CARD_SORT_OPTIONS[scenario];

    if (!creditCardSortOptions) {
        const badScenario = new RangeError(`[getCreditCardSortOptions] Unsupported scenario: “${scenario}”`);
        noticeError(badScenario);
        throw badScenario;
    }

    if (!isWidget()) {
        return creditCardSortOptions;
    }

    // REWARD_SORT_OPTIONS and LOW_INTEREST_SORT_OPTIONS are .frozen
    const widgetSortOptions = Object.assign({}, creditCardSortOptions);
    delete widgetSortOptions['RECOMMENDED'];

    return widgetSortOptions;
}

const CREDIT_CARD_SORT_OPTIONS = {
    [SCENARIOS.REWARDS]: REWARD_SORT_OPTIONS,
    [SCENARIOS.LOW_INTEREST]: LOW_INTEREST_SORT_OPTIONS,
    [SCENARIOS.BALANCE_TRANSFER]: LOW_INTEREST_SORT_OPTIONS,
};

export default getCreditCardSortOptions;
